// DS: B5
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import classnames from 'classnames';
import Button from '../Button';
import s from './ButtonB5.scss';
class ButtonB5 extends React.Component {
    render() {
        const _this_props = this.props, { className , children , withBackground =true  } = _this_props, rest = _object_without_properties(_this_props, [
            "className",
            "children",
            "withBackground"
        ]);
        return /*#__PURE__*/ React.createElement(Button, _extends({}, rest, {
            className: classnames(s['button'], withBackground && s['with-background'], className),
            fullWidth: false
        }), this.renderIcon(), children);
    }
    renderIcon() {
        const Component = this.props.icon;
        const _this_props_iconProps = this.props.iconProps, { className  } = _this_props_iconProps, rest = _object_without_properties(_this_props_iconProps, [
            "className"
        ]);
        return /*#__PURE__*/ React.createElement(Component, _extends({
            className: classnames(s['icon'], className)
        }, rest));
    }
}
export default ButtonB5;
